import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private http: HttpClient
  ) { }

  
    getAllUsers(body: any): Observable<any> {
        return this.http.post(environment.getAllUsers, body);
    }

    createUser(body: any): Observable<any> {
        return this.http.post(environment.createUser, body);
    }

    updateUser(body: any): Observable<any> {
        return this.http.post(environment.updateUser, body);
    }

    deleteUser(body: any): Observable<any> {
        return this.http.post(environment.deleteUser, body);
    }

 


}
